export default "__VITE_ASSET__Ivy6Nf3u__"